/* ============================================================
   CREATINGS STUDIO — THEME JS
   Psyminimal · Applied Structural Intelligence
   ============================================================ */

/* ── Header scroll state ── */
(function () {
  var header = document.getElementById('site-header');
  if (!header) return;
  var onScroll = function () {
    if (window.scrollY > 12) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* ── Mobile Menu ── */
function openMobileMenu() {
  var menu = document.getElementById('mobile-menu');
  if (!menu) return;
  menu.classList.add('is-open');
  menu.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}
function closeMobileMenu() {
  var menu = document.getElementById('mobile-menu');
  if (!menu) return;
  menu.classList.remove('is-open');
  menu.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

/* ── Cart Drawer ── */
function openCartDrawer() {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');
  if (!drawer) return;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  if (overlay) overlay.classList.add('is-visible');
  document.body.style.overflow = 'hidden';
}
function closeCartDrawer() {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  if (overlay) overlay.classList.remove('is-visible');
  document.body.style.overflow = '';
}

/* ── AJAX: Update cart item quantity ── */
function updateCartQty(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
  })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      refreshCartDrawer(cart);
    })
    .catch(function (err) { console.error('Cart update error:', err); });
}

/* ── AJAX: Add to cart ── */
function addToCart(variantId, quantity) {
  var btn = document.getElementById('product-add-btn');
  if (btn) {
    btn.textContent = 'Adding…';
    btn.disabled = true;
  }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: quantity || 1 })
  })
    .then(function (res) { return res.json(); })
    .then(function () {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      refreshCartDrawer(cart);
      openCartDrawer();
      if (btn) {
        btn.textContent = 'Added ✓';
        btn.disabled = false;
        setTimeout(function () { updateAddBtnLabel(); }, 1600);
      }
    })
    .catch(function (err) {
      console.error('Add to cart error:', err);
      if (btn) { btn.textContent = 'Error — try again'; btn.disabled = false; }
    });
}

function updateAddBtnLabel() {
  var btn = document.getElementById('product-add-btn');
  var priceEl = document.getElementById('product-price');
  if (btn && priceEl) {
    btn.textContent = 'Add to cart — ' + priceEl.textContent;
  }
}

/* ── AJAX: Rebuild cart drawer HTML ── */
function refreshCartDrawer(cart) {
  // Update count badges
  var countEls = document.querySelectorAll('#cart-count, #cart-drawer-count');
  countEls.forEach(function (el) {
    el.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
  });
  var headerCount = document.getElementById('cart-count');
  if (headerCount) {
    headerCount.style.display = cart.item_count > 0 ? '' : 'none';
  }

  // Update subtotal
  var subtotalEl = document.getElementById('cart-subtotal');
  if (subtotalEl) {
    subtotalEl.textContent = formatMoney(cart.total_price);
  }

  // Rebuild cart body
  var body = document.getElementById('cart-drawer-body');
  if (!body) return;

  if (cart.item_count === 0) {
    body.innerHTML = '<p class="cart-drawer__empty font-mono-xs">Your cart is empty.</p>';
    return;
  }

  var html = '';
  cart.items.forEach(function (item) {
    html += '<div class="cart-item" data-key="' + item.key + '">';
    html += '<div class="cart-item__img">';
    if (item.image) {
      html += '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" width="80" loading="lazy">';
    }
    html += '</div>';
    html += '<div class="cart-item__info">';
    html += '<p class="cart-item__title">' + escapeHtml(item.product_title) + '</p>';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      html += '<p class="cart-item__variant font-mono-xs">' + escapeHtml(item.variant_title) + '</p>';
    }
    html += '<div class="cart-item__qty">';
    html += '<button class="cart-item__qty-btn" onclick="updateCartQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button>';
    html += '<span>' + item.quantity + '</span>';
    html += '<button class="cart-item__qty-btn" onclick="updateCartQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>';
    html += '</div>';
    html += '</div>';
    html += '<div class="cart-item__price font-mono-xs">' + formatMoney(item.final_line_price) + '</div>';
    html += '</div>';
  });
  body.innerHTML = html;
}

/* ── Money formatter (Shopify cents → formatted string) ── */
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/* ── Product image swap ── */
function swapProductImage(src, alt) {
  var img = document.getElementById('product-featured-img');
  if (!img) return;
  img.src = src;
  img.alt = alt;
}

/* ── Product variant selection ── */
(function () {
  var optionInputs = document.querySelectorAll('.product-option input[type="radio"]');
  if (!optionInputs.length) return;

  optionInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      updateSelectedVariant();
    });
  });

  function getSelectedOptions() {
    var options = [];
    var groups = document.querySelectorAll('.product-option');
    groups.forEach(function (group) {
      var checked = group.querySelector('input:checked');
      if (checked) options.push(checked.value);
    });
    return options;
  }

  function updateSelectedVariant() {
    var selected = getSelectedOptions();
    // Shopify variants are embedded as JSON in a script tag for theme devs
    var variantData = document.getElementById('product-variant-data');
    if (!variantData) return;
    var variants = JSON.parse(variantData.textContent);
    var match = variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });
    if (match) {
      var idInput = document.getElementById('product-variant-id');
      if (idInput) idInput.value = match.id;
      var priceEl = document.getElementById('product-price');
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      var btn = document.getElementById('product-add-btn');
      if (btn) {
        if (match.available) {
          btn.textContent = 'Add to cart — ' + formatMoney(match.price);
          btn.disabled = false;
          btn.classList.remove('product-page__add-btn--unavailable');
          btn.onclick = function () { addToCart(match.id, 1); };
        } else {
          btn.textContent = 'Sold out';
          btn.disabled = true;
          btn.classList.add('product-page__add-btn--unavailable');
        }
      }
    }
  }
})();

/* ── Scroll reveal (FadeUp equivalent) ── */
(function () {
  var els = document.querySelectorAll('.fade-up, [data-fade-up]');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  els.forEach(function (el) { el.classList.add('fade-up'); observer.observe(el); });
})();

/* ── Parallax scroll images ── */
(function () {
  var imgs = document.querySelectorAll('.js-scroll-img');
  if (!imgs.length) return;

  function onScroll() {
    imgs.forEach(function (img) {
      var wrap = img.closest('.js-scroll-img-wrap') || img.closest('.hero__media') || img.parentElement;
      var rect = wrap ? wrap.getBoundingClientRect() : img.getBoundingClientRect();
      var vh = window.innerHeight;
      if (rect.bottom < 0 || rect.top > vh) return;
      var progress = (vh - rect.top) / (vh + rect.height);
      var offset = (progress - 0.5) * 30;
      img.style.transform = 'translateY(' + offset + 'px) scale(1.08)';
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* ── Hero parallax content ── */
(function () {
  var heroContent = document.querySelector('[data-parallax-content]');
  if (!heroContent) return;
  function onScroll() {
    var y = window.scrollY;
    heroContent.style.transform = 'translateY(' + (y * 0.22) + 'px)';
    heroContent.style.opacity = Math.max(0, 1 - y / (window.innerHeight * 0.7));
  }
  window.addEventListener('scroll', onScroll, { passive: true });
})();

/* ── Work archive filter ── */
(function () {
  var filterBtns = document.querySelectorAll('.work-filter__btn');
  if (!filterBtns.length) return;
  var items = document.querySelectorAll('.work-folder');

  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      filterBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var filter = btn.dataset.filter;
      items.forEach(function (item) {
        if (filter === 'all' || item.dataset.category === filter) {
          item.style.display = '';
        } else {
          item.style.display = 'none';
        }
      });
    });
  });
})();

/* ── Keyboard close for drawers / menus ── */
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    closeMobileMenu();
    closeCartDrawer();
  }
});
